import React, {  useState } from "react";
import {
  Box,
  Typography,
  Chip,
  CircularProgress,
  Alert,
  
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  TextField,
  Card,
} from "@mui/material";
import { CalendarToday } from "@mui/icons-material";

import {
  useGetFinancialTransactionsQuery,
} from "../../../redux/Slices/financial-transactionsApi";

import { useGetFinancialPeriodsQuery } from "../../../redux/Slices/financial-periodsApi";
import detectFiscalPeriod from "hooks/detectFiscalPeriod";
import { useGetFinancialAccountsQuery } from "../../../redux/Slices/financial-accountsApi";
import MDBox from "components/MDBox";
import RTLDataGrid from "components/styled-component/RTLDataGrid";

// create Financial Transactions Report
const FinancialTransactionsReport = () => {
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 10,
    page: 0,
  });
  const [accountId, setAccountId] = useState(null);
  const { data: accounts, isLoading: accountsLoading } = useGetFinancialAccountsQuery(1);
  const [periodId, setPeriodId] = useState(() => {
    return detectFiscalPeriod(new Date().toISOString().split("T")[0]);
  });
  const [startDate, setStartDate] = useState(new Date().toISOString().split("T")[0]);
  const [endDate, setEndDate] = useState(() => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow.toISOString().split("T")[0];
  });
  // Filter Query by Fiscal Period ID, Start Date, End Date
  const [filterQuery, setFilterQuery] = useState(
    () =>
      new URLSearchParams({
        fiscal_period_id: periodId?.toString(),
        start_date: startDate,
        end_date: endDate,
      })
  );
  // get Financial Transactions Data
  const {
    data: incomeDataPerPeriod,
    isLoading,
    isError,
    error,
  } = useGetFinancialTransactionsQuery(filterQuery.toString());

  const { data: periods, isLoading: periodsLoading } = useGetFinancialPeriodsQuery();

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("ar-EG", {
      style: "currency",
      currency: "EGP",
      minimumFractionDigits: 2,
    }).format(amount);
  };

  // DataGrid Columns for Revenues
  const columns = [
    {
      field: "account_code",
      headerName: "كود الحساب",
      flex: 1,
      minWidth: 120,
    },

    {
      field: "account_name",
      headerName: "اسم الحساب",
      flex: 2,
      minWidth: 200,
    },
    {
      field: "description",
      headerName: "الوصف",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "reference",
      headerName: "المرجع",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "debit_amount",
      headerName: "مدين",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "credit_amount",
      headerName: "دائن",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "balance",
      headerName: "الرصيد",
      flex: 1,
      minWidth: 150,

      valueFormatter: (params) => formatCurrency(params),
    },
    {
      field: "data",
      headerName: "التاريخ",
      flex: 1,
      minWidth: 150,
    },
  ];

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <CircularProgress />
      </Box>
    );
  }

  if (isError) {
    return (
      <Box p={3}>
        <Alert severity="error">
          حدث خطأ أثناء تحميل البيانات: {error?.data?.message || "خطأ غير معروف"}
        </Alert>
      </Box>
    );
  }

  const reportData = incomeDataPerPeriod?.data;
  const meta = incomeDataPerPeriod?.meta;
  console.log("🚀 ~ FinancialTransactionsReport ~ meta:", meta);

  return (
    <MDBox  p={3}>
     
      <Card>

      
      {/* Header */}
      
        <MDBox
           mx={2}
            mt={-3}
            py={3}
            px={2}
            borderRadius="lg"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              background: "linear-gradient(90deg, #ca9937, #e0b15a)",
              boxShadow: 3,
            }}
          flexWrap="wrap"
          gap={2}
        >
          <Box>
            <Typography variant="h4" fontWeight="bold" gutterBottom>
              قائمة المعاملات المالية
            </Typography>
            <Box display="flex" alignItems="center" gap={1}>
              <CalendarToday fontSize="small" color="action" />
              <Typography variant="body2" color="text.secondary">
                {meta?.fiscal_period}
              </Typography>
              <Chip
                label={`${meta?.period?.start_date} - ${meta?.period?.end_date}`}
                size="small"
                variant="outlined"
                color="text.main"
                sx={{
                  borderColor: "text.main",
                  p: 1,
                }}
              />
            </Box>
          </Box>
          <Typography variant="caption" color="text.secondary">
            تم الإنشاء في: {meta?.generated_at}
          </Typography>
        </MDBox>
      

      <Box display="flex" gap={2} m={3}>
        <FormControl sx={{ mb: 2, minWidth: 200 }} flex={1}>
          <InputLabel id="account"> اختر الحساب </InputLabel>
          <Select
            label="اختر الحساب "
            /* error={!!errors.type} */
            name="account"
            value={accountId}
            onChange={(e) => {
              setAccountId(e.target.value);
              setFilterQuery((prev) => {
                return new URLSearchParams({
                  ...Object.fromEntries(prev.entries()),
                  account_id: e.target.value,
                });
              });
            }}
            sx={{ height: 43 }}
          >
            {accounts?.data?.map((account) => (
              <MenuItem key={account.id} value={account.id}>
                {account.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl flex={1} sx={{ mb: 2 }}>
          <InputLabel id="type"> اختر الفترة </InputLabel>
          <Select
            label="اختر الفترة "
            /* error={!!errors.type} */
            name="type"
            value={periodId}
            onChange={(e) => {
              setPeriodId(e.target.value);
            }}
            sx={{ height: 43 }}
          >
            {periods?.data?.map((period) => (
              <MenuItem key={period.id} value={period.id}>
                {period.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl flex={1} sx={{}}>
          <TextField
            id="start-date"
            type="date"
            value={startDate}
            onChange={(e) => {
              if (e.target.value > endDate) {
                setEndDate(e.target.value);
              }
              const fiscalPeriod = detectFiscalPeriod(e.target.value);
              setPeriodId(fiscalPeriod);
              setStartDate(e.target.value);
              setEndDate(() => {
                const newEndDate = new Date(e.target.value);
                newEndDate.setDate(newEndDate.getDate() + 1);
                return newEndDate.toISOString().split("T")[0];
              });
            }}
            sx={{}}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </FormControl>
        <FormControl flex={1} sx={{}}>
          <TextField
            id="end-date"
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            sx={{}}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </FormControl>
      </Box>

      {/* Revenues DataGrid */}
     
        
          <RTLDataGrid
            rows={reportData?.data || []}
            columns={columns}
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
            pageSizeOptions={[5, 10, 25, 50]}
            getRowId={(row) => row.account_code}
            disableRowSelectionOnClick
            isActions={false}
          />
         
      </Card>
    </MDBox>
  );
};

export default FinancialTransactionsReport;
